module.exports = __webpack_public_path__ + "img/icon_plus_round.66932d24.svg";